// extracted by mini-css-extract-plugin
export default {"projectGrid":"ProjectsSlider_projectGrid__HSOym"};